import React, { useEffect, useRef, useState } from "react";
import {
  Card,
  Typography,
  Box,
  LinearProgress,
  Grid,
  IconButton,
  Paper,
  useMediaQuery,
  SvgIcon,
  Button,
  useTheme,
} from "@mui/material";
import "./Exam_History.scss"; // Import SCSS styles
import { useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../Redux/Store/Hooks";
import { listExamHistory } from "../../Redux/Slices/ExamHistory/ListExamHistorySlice";
import {
  clearListExamID,
  listExamID,
} from "../../Redux/Slices/Exam/ListExamIDSlice";
import { listReViewExamID } from "../../Redux/Slices/ReViewExam/ListReViewExamSlice";
import {
  clearListReExamID,
  listReExamID,
} from "../../Redux/Slices/ReExam/ListReExamSlice";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import { listExamHistoryReWritingSlice } from "../../Redux/Slices/ExamHistory/ListExamHistoryReWritingSlice";
import {
  clearlistEvaluationPracticewritingExam,
  listEvaluationPracticewritingExam,
} from "../../Redux/Slices/PracticeExam/ListEvaluationPracticewritingExamSlice";
import { listEvaluationPractice } from "../../Redux/Slices/PracticeExam/ListEvaluationPracticeSlice";
import { addStudentExam } from "../../Redux/Slices/StudentExam/AddStudentExamSlice";
import { listInstructionExamID } from "../../Redux/Slices/Exam/ListinstructionExamIDSlice";
import { ILoginResponse } from "../Login/ILogin";
import { decode } from "../../Utils/encodeDecode";
import { listMockExamHistory } from "../../Redux/Slices/ExamHistory/ListMockExamHistorySlice";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { ReactComponent as Report } from "./ImageExamhistory/Report.svg";
import { ReactComponent as Examattemped } from "./ImageExamhistory/Examattemped.svg";
import { ReactComponent as Feedback } from "./ImageExamhistory/Feedbackicon.svg";
import Menus from "../../Components/Menu/Menu";
import { clearListuser, listUser } from "../../Redux/Slices/User/ListUserSlice";
import { clearLoginStatus } from "../../Redux/Slices/LoginSlicer/LoginSlicer";
import IconButtonField from "../../Components/Button/IconButtonField";
import Avatars from "../../Components/Avatar/Avatars";
import { listReExamPracticeID } from "../../Redux/Slices/ReExamPractice/ListReExamPracticeSlice";
import { log } from "console";
import { clearlistStudentExam } from "../../Redux/Slices/StudentExam/ListStudentExamSlice";
import { clearDashboardChart } from "../../Redux/Slices/DashboardChart/DashboardChart";
import { ReactComponent as document_icon } from "../../Assets/Images/document_icon.svg";
import RefreshOutlinedIcon from "@mui/icons-material/RefreshOutlined";
import { clearpendingPracticeExam } from "../../Redux/Slices/PendingPracticeExam/PendingPracticeExamSlice";
import { clearEditStudentExamPracticeResponse } from "../../Redux/Slices/StudentExamPractice/EditStudentExamPracticeSlice";

const ExamHistory = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const { data: ListMockExamHistorySlice } = useAppSelector(
    (state) => state.ListMockExamHistorySlice
  );
  const { data: ListExamHistorySlice } = useAppSelector(
    (state) => state.ListExamHistorySlice
  );
  const { data: ListExamHistoryreSlice } = useAppSelector(
    (state) => state.ListExamHistoryReWritingSlice
  );
  const { data: AddFeedBackSlice } = useAppSelector(
    (state) => state.AddFeedBackSlice
  );
  const MockExamHistorySlicelist: any = ListMockExamHistorySlice?.data;
  const ExamHistorySlicelist: any = ListExamHistorySlice?.data;
  const ExamHistorySliceRElist: any = ListExamHistoryreSlice?.data;

  useEffect(() => {
    dispatch(listMockExamHistory());
    dispatch(listExamHistory());
    dispatch(listExamHistoryReWritingSlice());
  }, [dispatch, AddFeedBackSlice]);

  // down arrow
  const [showArrow, setShowArrow] = useState(false);
  const containerRef = useRef(null);

  useEffect(() => {
    const handleScroll = () => {
      const container = containerRef.current;
      if (container) {
        const { scrollTop, scrollHeight, clientHeight } = container;
        setShowArrow(scrollHeight - scrollTop > clientHeight + 1); // Show arrow if not at the bottom
      }
    };

    const container: any = containerRef.current;
    if (container) {
      container.addEventListener("scroll", handleScroll);
      handleScroll(); // Initial check
    }

    return () => {
      if (container) {
        container.removeEventListener("scroll", handleScroll);
      }
    };
  }, []);

  const [details, setDetails] = useState<ILoginResponse>({});

  useEffect(() => {
    const userDetails = decode(sessionStorage.getItem("details"));
    setDetails(userDetails);
  }, []);

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isTablet = useMediaQuery(theme.breakpoints.between("sm", "md"));
  const isLaptop = useMediaQuery(theme.breakpoints.between("md", "lg"));

  // jnsjc

  const [startIndex, setStartIndex] = useState(0);
  const cardsPerPage = isMobile ? 1 : isTablet ? 2 : isLaptop ? 2 : 3; // Number of cards to show at a time

  // Next Page
  const handleNext = () => {
    if (startIndex + cardsPerPage < MockExamHistorySlicelist?.length) {
      setStartIndex((prev) => prev + cardsPerPage);
    }
  };

  // Previous Page
  const handlePrev = () => {
    if (startIndex > 0) {
      setStartIndex((prev) => prev - cardsPerPage);
    }
  };

  const [startIndextest, setStartIndextest] = useState(0);
  const cardsPerPagetest = isMobile ? 1 : isTablet ? 2 : isLaptop ? 2 : 3; // Number of cards to show at a time

  const handleNexttest = () => {
    if (startIndextest + cardsPerPagetest < ExamHistorySliceRElist?.length) {
      setStartIndextest((prev) => prev + cardsPerPagetest);
    }
  };

  // Previous Page
  const handlePrevtest = () => {
    if (startIndextest > 0) {
      setStartIndextest((prev) => prev - cardsPerPagetest);
    }
  };
  const [startIndexexam, setStartIndexexam] = useState(0);
  const cardsPerPageexam = isMobile ? 1 : isTablet ? 2 : isLaptop ? 2 : 3; // Number of cards to show at a time

  const handleNextexam = () => {
    if (startIndexexam + cardsPerPageexam < ExamHistorySlicelist?.length) {
      setStartIndexexam((prev) => prev + cardsPerPagetest);
    }
  };

  // Previous Page
  const handlePrevexam = () => {
    if (startIndexexam > 0) {
      setStartIndexexam((prev) => prev - cardsPerPageexam);
    }
  };

  useEffect(() => {
    dispatch(listUser());
  }, [dispatch]);
  const { data: ListUserSliceLoading } = useAppSelector(
    (state) => state.ListUserSlice
  );
  const ListUser: any = Array.isArray(ListUserSliceLoading?.data)
    ? ListUserSliceLoading?.data.map((user, index) => ({
        ...user,
        index: index + 1,
      }))
    : [];
  return (
    <>
      <div className="DashboardStudentAlingments">
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginBottom: "20px",
          }}
        >
          <div>
            <div
              className="DashboardStudent"
              style={{ fontWeight: "700", fontSize: "24px" }}
            >
              History
            </div>
            <div className="StudentPractice">
              View your past exams and performance
            </div>
          </div>
          <div>
            <Menus
              menuItems={[
                // {
                //   menu: "Profile",
                //   onClick: () => {
                //     nav("/studentprofile");
                //   },
                // },
                {
                  menu: "Logout",
                  onClick: () => {
                    sessionStorage.clear();
                    dispatch(clearListuser());
                    dispatch(clearLoginStatus());
                    dispatch(clearDashboardChart());
                    navigate("/login");
                  },
                },
              ]}
            >
              <IconButtonField onClick={() => {}}>
                <Avatars sx={{ height: "2rem", width: "2rem" }} />
              </IconButtonField>
            </Menus>
            <span className="Username">{ListUser[0]?.student_name}</span>
          </div>
        </div>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "5px",
            justifyContent: "flex-end",
          }}
        >
          <IconButton
            onClick={handlePrev}
            disabled={startIndex === 0}
            sx={{ border: "1px solid" }}
          >
            <ChevronLeftIcon />
          </IconButton>
          <IconButton
            onClick={handleNext}
            sx={{ border: "1px solid" }}
            disabled={
              startIndex + cardsPerPage >= MockExamHistorySlicelist?.length
            }
          >
            <ChevronRightIcon />
          </IconButton>
        </div>
        <div
          className="DashboardStudent"
          style={{
            padding: "0% 0% 0% 0%",
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <div className="HistoryStudent">
            Mini Mock Exams
            <p style={{ margin: "0", fontSize: "14px", color: "#4B5563" }}>
              Each attempt is shown separately - retake any specific attempt to
              get the same questions
            </p>
          </div>
        </div>

        <Box sx={{ margin: "auto", p: 0 }}>
          <Box sx={{ display: "flex", alignItems: "center" }}>
            {/* Cards Grid */}
            <Grid container spacing={3} sx={{ flex: 1, overflow: "hidden" }}>
              {MockExamHistorySlicelist &&
              MockExamHistorySlicelist?.length > 0 ? (
                MockExamHistorySlicelist?.slice(
                  startIndex,
                  startIndex + cardsPerPage
                ).map((history: any, index: any) => {
                  // Define ECharts option inside the map function
                  const d = new Date(history?.exit_time);
                  const formattedDate = `${d.toLocaleDateString("en-GB", {
                    day: "2-digit",
                    month: "2-digit",
                    year: "numeric",
                  })} ${d.toLocaleTimeString("en-GB", {
                    hour: "numeric",
                    minute: "2-digit",
                    hour12: true,
                  })}`;

                  const feedbackText = Array.isArray(history?.feed_back)
                    ? history.feed_back
                        .map((item: any) => item.feedback)
                        .join(", ") || "Skipped"
                    : history?.feed_back || "Skipped";
                  console.log("feedbackText", feedbackText);

                  return (
                    <Grid
                      item
                      xs={12}
                      sm={6}
                      md={6}
                      lg={4}
                      key={index}
                      sx={{ marginBottom: "24px" }}
                    >
                      <Paper
                        elevation={3}
                        sx={{
                          p: 2,
                          borderRadius: 2,
                          height: "100%",
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "space-between",
                          boxShadow: "0 2px 12px rgba(0,0,0,0.05)",
                        }}
                      >
                        <Typography
                          variant="h5"
                          sx={{
                            fontWeight: 600,
                            mb: 1,
                            fontSize: "16px",
                            marginBottom: "12px",
                          }}
                        >
                          {history?.exam_name} - Attempt{" "}
                          {history?.retake_count ?? 1}/1
                        </Typography>
                        {/* Date + Status Row */}
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: 1,
                            mb: 1,
                            justifyContent: "space-between",
                          }}
                        >
                          <Box
                            sx={{
                              fontSize: "12px",
                              backgroundColor: "#f1f5f9",
                              px: 1.2,
                              py: 0.5,
                              borderRadius: "8px",
                            }}
                          >
                            {formattedDate ?? "NA"}
                          </Box>

                          <Box
                            sx={{
                              fontSize: "12px",
                              backgroundColor:
                                feedbackText === "Very Difficult"
                                  ? "#ef4444"
                                  : feedbackText === "Difficult"
                                  ? "#f97316"
                                  : feedbackText === "Moderate"
                                  ? "#facc15"
                                  : feedbackText === "Easy"
                                  ? "#86efac"
                                  : feedbackText === "Very Easy"
                                  ? "#22c55e"
                                  : "#ffedd5",
                              color:
                                feedbackText === "Very Difficult"
                                  ? "#ffffff"
                                  : feedbackText === "Difficult"
                                  ? "#ffffff"
                                  : feedbackText === "Moderate"
                                  ? "#78350f"
                                  : feedbackText === "Easy"
                                  ? "#064e3b"
                                  : feedbackText === "Very Easy"
                                  ? "#ffffff"
                                  : "#c2410c",
                              px: 1.2,
                              py: 0.5,
                              borderRadius: "8px",
                              display: "flex",
                              alignItems: "center",
                              fontWeight: 600,
                            }}
                          >
                            {feedbackText === "Very Difficult"
                              ? "😠 Very Difficult"
                              : feedbackText === "Difficult"
                              ? "😧 Difficult"
                              : feedbackText === "Moderate"
                              ? "😐 Moderate"
                              : feedbackText === "Easy"
                              ? "☺️ Easy"
                              : feedbackText === "Very Easy"
                              ? "😄 Very Easy"
                              : "⏩ Feedback Skipped"}
                          </Box>
                        </Box>
                        <Typography
                          variant="body2"
                          sx={{
                            color: "#4b5563",
                            fontSize: "14px",
                            lineHeight: 1.6,
                            mb: 2,
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            display: "-webkit-box",
                            WebkitLineClamp: 3,
                            WebkitBoxOrient: "vertical",
                          }}
                        >
                          {history?.exam_description}
                        </Typography>
                        <Box sx={{ display: "flex", gap: 2 }}>
                          {/* <Button
                            variant="contained"
                            sx={{
                              backgroundColor: "#0ea5e9",
                              textTransform: "none",
                              fontSize: "14px",
                              px: 2,
                              py: 1,
                              borderRadius: "8px",
                              color: "white",
                              flex: 1,
                              "&:hover": {
                                backgroundColor: "#0284c7",
                              },
                            }}
                            onClick={() => {
                              if (history?.retake_id) {
                                dispatch(
                                  listReExamPracticeID({
                                    student_test_id: history.retake_id,
                                  })
                                );
                                navigate("/reexaminstruction", {
                                  state: history?.retake_id,
                                });
                              }
            20            }}
                          >
                            🔁 Retake Test
                          </Button> */}

                          <Button
                            variant="outlined"
                            sx={{
                              textTransform: "none",
                              fontSize: "15px",
                              px: 2,
                              py: 1,
                              gap: "8px",
                              borderRadius: "8px",
                              flex: 1,
                              borderColor: "#cbd5e1",
                              "&:hover": {
                                color: "white",
                                backgroundColor: "#38C172",
                              },
                              color: "#0f172a",
                            }}
                            onClick={() =>
                              navigate("/examresult", {
                                state: {
                                  id: history?.id,
                                  showSubmitAlert: false, // or true if you want the alert
                                },
                              })
                            }
                          >
                            <SvgIcon
                              component={document_icon}
                              inheritViewBox
                              sx={{
                                fill: "none",
                                fontSize: "16px",
                              }}
                            />
                            View Report
                          </Button>
                        </Box>
                      </Paper>
                    </Grid>
                  );
                })
              ) : (
                <Grid item xs={12} sm={6} md={4} sx={{ marginBottom: "24px" }}>
                  <Paper
                    elevation={3}
                    sx={{
                      p: 2,
                      borderRadius: 2,
                      height: "100%",
                      display: "flex",
                      flexDirection: "column",
                      boxShadow: "none",
                    }}
                  >
                    {/* Card Header */}
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <Typography
                        component="h2"
                        sx={{
                          fontSize: "18px",
                          fontWeight: "medium",
                        }}
                      >
                        No Mock Exams History Available
                      </Typography>
                    </Box>
                    <div
                      className="descritpionlist"
                      style={{
                        color: "#575757",
                        marginTop: "10px",
                        marginBottom: "10px",
                      }}
                    >
                      {" "}
                      You don't have any mock exam history at the moment. Please
                      attempt a mock exam to see your progress here.
                    </div>
                    <div>
                      <div
                        style={{
                          display: "flex",
                          gap: "10px",
                          width: "100%",
                          alignItems: "center",
                          justifyContent: "flex-end",
                        }}
                      >
                        <button
                          className="card-buttonexam"
                          onClick={() => {
                            navigate("/dashboard");
                          }}
                        >
                          <SvgIcon
                            component={Report}
                            inheritViewBox
                            sx={{ fill: "none" }}
                          />
                          <div style={{ fontSize: "14px" }}> Back to home</div>
                        </button>
                      </div>
                    </div>
                  </Paper>
                </Grid>
              )}
            </Grid>
          </Box>
        </Box>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "5px",
            justifyContent: "flex-end",
            marginTop: "24px",
          }}
        >
          <IconButton
            onClick={handlePrevtest}
            disabled={startIndextest === 0}
            sx={{ border: "1px solid" }}
          >
            <ChevronLeftIcon />
          </IconButton>
          <IconButton
            onClick={handleNexttest}
            sx={{ border: "1px solid" }}
            disabled={
              startIndextest + cardsPerPagetest >=
              ExamHistorySliceRElist?.length
            }
          >
            <ChevronRightIcon />
          </IconButton>
        </div>
        <div
          className="DashboardStudent"
          style={{
            padding: "0% 0% 0% 0%",
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <div className="HistoryStudent">
            Practice Tests
            <p style={{ margin: "0", fontSize: "14px", color: "#4B5563" }}>
              Each attempt is shown separately - retake any specific attempt to
              get the same questions
            </p>
          </div>
        </div>

        <Box sx={{ margin: "auto", p: 0 }}>
          <Box sx={{ display: "flex", alignItems: "center" }}>
            {/* Cards Grid */}
            <Grid container spacing={3} sx={{ flex: 1, overflow: "hidden" }}>
              {ExamHistorySliceRElist && ExamHistorySliceRElist?.length > 0 ? (
                ExamHistorySliceRElist?.slice(
                  startIndextest,
                  startIndextest + cardsPerPagetest
                ).map((history: any, index: any) => {
                  // Define ECharts option inside the map function
                  const d = new Date(history?.exit_time);
                  const formattedDate = `${d.toLocaleDateString("en-GB", {
                    day: "2-digit",
                    month: "2-digit",
                    year: "numeric",
                  })} ${d.toLocaleTimeString("en-GB", {
                    hour: "numeric",
                    minute: "2-digit",
                    hour12: true,
                  })}`;

                  const feedbackText = Array.isArray(history?.feedback)
                    ? history.feedback
                        .map((item: any) => item.feedback)
                        .join(", ") || "Skipped"
                    : history?.feedback || "Skipped";
                  console.log("practise state history", feedbackText);

                  return (
                    <Grid
                      item
                      xs={12}
                      sm={6}
                      md={6}
                      lg={4}
                      key={index}
                      sx={{ marginBottom: "24px" }}
                    >
                      <Paper
                        elevation={3}
                        sx={{
                          p: 2,
                          borderRadius: 2,
                          height: "100%",
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "space-between",
                          boxShadow: "0 2px 12px rgba(0,0,0,0.05)",
                        }}
                      >
                        {/* Header: Title + Status */}
                        <Typography
                          variant="h5"
                          sx={{
                            fontWeight: 600,
                            mb: 1,
                            fontSize: "16px",
                            marginBottom: "12px",
                          }}
                        >
                          {history?.test_name} - Attempt{" "}
                          {history?.retake_count ?? 1}/1
                        </Typography>

                        {/* Date + Status Row */}
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: 1,
                            mb: 1,
                            justifyContent: "space-between",
                          }}
                        >
                          <Box
                            sx={{
                              fontSize: "12px",
                              backgroundColor: "#f1f5f9",
                              px: 1.2,
                              py: 0.5,
                              borderRadius: "8px",
                            }}
                          >
                            {formattedDate ?? "NA"}
                          </Box>

                          <Box
                            sx={{
                              fontSize: "12px",
                              backgroundColor:
                                feedbackText === "Very Difficult"
                                  ? "#ef4444"
                                  : feedbackText === "Difficult"
                                  ? "#f97316"
                                  : feedbackText === "Moderate"
                                  ? "#facc15"
                                  : feedbackText === "Easy"
                                  ? "#86efac"
                                  : feedbackText === "Very Easy"
                                  ? "#22c55e"
                                  : "#ffedd5",
                              color:
                                feedbackText === "Very Difficult"
                                  ? "#ffffff"
                                  : feedbackText === "Difficult"
                                  ? "#ffffff"
                                  : feedbackText === "Moderate"
                                  ? "#78350f"
                                  : feedbackText === "Easy"
                                  ? "#064e3b"
                                  : feedbackText === "Very Easy"
                                  ? "#ffffff"
                                  : "#c2410c",
                              px: 1.2,
                              py: 0.5,
                              borderRadius: "8px",
                              display: "flex",
                              alignItems: "center",
                              fontWeight: 600,
                            }}
                          >
                            {feedbackText === "Very Difficult"
                              ? "😠 Very Difficult"
                              : feedbackText === "Difficult"
                              ? "😧 Difficult"
                              : feedbackText === "Moderate"
                              ? "😐 Moderate"
                              : feedbackText === "Easy"
                              ? "☺️ Easy"
                              : feedbackText === "Very Easy"
                              ? "😄 Very Easy"
                              : "⏩ Feedback Skipped"}
                          </Box>
                        </Box>

                        {/* Description */}
                        <Typography
                          variant="body2"
                          sx={{
                            color: "#4b5563",
                            fontSize: "14px",
                            lineHeight: 1.6,
                            mb: 2,
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            display: "-webkit-box",
                            WebkitLineClamp: 3,
                            WebkitBoxOrient: "vertical",
                          }}
                        >
                          {history?.test_description}
                        </Typography>

                        {/* Buttons */}
                        <Box sx={{ display: "flex", gap: 2 }}>
                          <Button
                            variant="contained"
                            sx={{
                              backgroundColor: "#0055ff",
                              textTransform: "none",
                              fontSize: "15px",
                              px: 2,
                              gap: "6px",
                              py: 1,
                              borderRadius: "8px",
                              color: "white",
                              flex: 1,
                              "&:hover": {
                                backgroundColor: "#0055ff",
                              },
                            }}
                            onClick={() => {
                              dispatch(clearEditStudentExamPracticeResponse());
                              dispatch(clearpendingPracticeExam());
                              dispatch(
                                clearlistEvaluationPracticewritingExam()
                              );
                              if (history?.retake_id) {
                                dispatch(
                                  listReExamPracticeID({
                                    student_test_id: history.retake_id,
                                  })
                                );
                                navigate("/reexaminstruction", {
                                  state: history?.retake_id,
                                });
                              }
                            }}
                          >
                            <RefreshOutlinedIcon
                              sx={{
                                transform: "scaleX(-1)",
                                fontSize: "20px",
                              }}
                            />
                            Retake Test
                          </Button>

                          <Button
                            variant="outlined"
                            sx={{
                              textTransform: "none",
                              fontSize: "15px",
                              px: 2,
                              py: 1,
                              gap: "6px",
                              borderRadius: "8px",
                              flex: 1,
                              borderColor: "#cbd5e1",
                              "&:hover": {
                                color: "white",
                                backgroundColor: "#38C172",
                              },
                              color: "#020817",
                            }}
                            onClick={() => {
                              if (history?.test_name === "Writing Test") {
                                dispatch(
                                  listEvaluationPracticewritingExam({
                                    student_test_id: history?.id,
                                  })
                                );

                                navigate("/examresultpractice", {
                                  state: {
                                    id: history?.id,
                                    student_id: history?.student_id,
                                    type: "Writing",
                                  },
                                });
                              } else {
                                dispatch(
                                  listEvaluationPractice({
                                    student_test_id: history?.id,
                                  })
                                );

                                navigate("/examresultpractice", {
                                  state: {
                                    id: history?.id,
                                    student_id: history?.student_id,
                                    showSubmitAlert: false, // or true if you want the alert
                                  },
                                });
                              }
                            }}
                          >
                            <SvgIcon
                              component={document_icon}
                              inheritViewBox
                              sx={{
                                fill: "none",
                                fontSize: "16px",
                              }}
                            />
                            View Report
                          </Button>
                        </Box>
                      </Paper>
                    </Grid>
                  );
                })
              ) : (
                <Grid item xs={12} sm={6} md={4} sx={{ marginBottom: "24px" }}>
                  <Paper
                    elevation={3}
                    sx={{
                      p: 2,
                      borderRadius: 2,
                      height: "100%",
                      display: "flex",
                      flexDirection: "column",
                      boxShadow: "none",
                    }}
                  >
                    {/* Card Header */}
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <Typography
                        component="h2"
                        sx={{
                          fontSize: "18px",
                          fontWeight: "medium",
                        }}
                      >
                        No Practice Test History Available
                      </Typography>
                    </Box>
                    <div
                      className="descritpionlist"
                      style={{
                        color: "#575757",
                        marginTop: "10px",
                        marginBottom: "10px",
                      }}
                    >
                      {" "}
                      You don't have any practice test history at the moment.
                      Please attempt a practice test to see your progress here.
                    </div>
                    <div>
                      <div
                        style={{
                          display: "flex",
                          gap: "10px",
                          width: "100%",
                          alignItems: "center",
                          justifyContent: "flex-end",
                        }}
                      >
                        <button
                          className="card-buttonexam"
                          onClick={() => {
                            navigate("/dashboard");
                          }}
                        >
                          {/* <SvgIcon
                            component={Report}
                            inheritViewBox
                            sx={{ fill: "none" }}
                          /> */}
                          <div style={{ fontSize: "14px" }}> Back to home</div>
                        </button>
                      </div>
                    </div>
                  </Paper>
                </Grid>
              )}
            </Grid>
          </Box>
        </Box>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "5px",
            justifyContent: "flex-end",
            marginTop: "24px",
          }}
        >
          <IconButton
            onClick={handlePrevexam}
            disabled={startIndexexam === 0}
            sx={{ border: "1px solid" }}
          >
            <ChevronLeftIcon />
          </IconButton>
          <IconButton
            onClick={handleNextexam}
            sx={{ border: "1px solid" }}
            disabled={
              startIndexexam + cardsPerPageexam >= ExamHistorySlicelist?.length
            }
          >
            <ChevronRightIcon />
          </IconButton>
        </div>
        <div
          className="DashboardStudent"
          style={{
            padding: "0% 0% 0% 0%",
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <div className="HistoryStudent">
            Mock Exams
            <p style={{ margin: "0", fontSize: "14px", color: "#4B5563" }}>
              Each attempt is shown separately - retake any specific attempt to
              get the same questions
            </p>
          </div>
        </div>

        <Box sx={{ margin: "auto", p: 0 }}>
          <Box sx={{ display: "flex", alignItems: "center" }}>
            {/* Cards Grid */}
            <Grid container spacing={3} sx={{ flex: 1, overflow: "hidden" }}>
              {ExamHistorySlicelist && ExamHistorySlicelist?.length > 0 ? (
                ExamHistorySlicelist?.slice(
                  startIndexexam,
                  startIndexexam + cardsPerPageexam
                ).map((history: any, index: any) => {
                  // Define ECharts option inside the map function

                  const d = new Date(history?.exit_time);
                  const formattedDate = `${d.toLocaleDateString("en-GB", {
                    day: "2-digit",
                    month: "2-digit",
                    year: "numeric",
                  })} ${d.toLocaleTimeString("en-GB", {
                    hour: "numeric",
                    minute: "2-digit",
                    hour12: true,
                  })}`;

                  const feedbackText = Array.isArray(history?.feed_back)
                    ? history.feed_back
                        .map((item: any) => item.feedback)
                        .join(", ") || "Skipped"
                    : history?.feed_back || "Skipped";
                  console.log("feedbackText", feedbackText);

                  return (
                    <Grid
                      item
                      xs={12}
                      sm={6}
                      md={6}
                      lg={4}
                      key={index}
                      sx={{ marginBottom: "24px" }}
                    >
                      <Paper
                        elevation={3}
                        sx={{
                          p: 2,
                          borderRadius: 2,
                          height: "100%",
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "space-between",
                          boxShadow: "0 2px 12px rgba(0,0,0,0.05)",
                        }}
                      >
                        <Typography
                          variant="h5"
                          sx={{
                            fontWeight: 600,
                            mb: 1,
                            fontSize: "16px",
                            marginBottom: "12px",
                          }}
                        >
                          {history?.exam_name}- Attempt{" "}
                          {history?.retake_count ?? 1}/1
                        </Typography>
                        {/* Card Header */}
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: 1,
                            mb: 1,
                            justifyContent: "space-between",
                          }}
                        >
                          <Box
                            sx={{
                              fontSize: "12px",
                              backgroundColor: "#f1f5f9",
                              px: 1.2,
                              py: 0.5,
                              borderRadius: "8px",
                            }}
                          >
                            {formattedDate ?? "NA"}
                          </Box>
                          <Box
                            sx={{
                              fontSize: "12px",
                              backgroundColor:
                                feedbackText === "Very Difficult"
                                  ? "#ef4444"
                                  : feedbackText === "Difficult"
                                  ? "#f97316"
                                  : feedbackText === "Moderate"
                                  ? "#facc15"
                                  : feedbackText === "Easy"
                                  ? "#86efac"
                                  : feedbackText === "Very Easy"
                                  ? "#22c55e"
                                  : "#ffedd5",
                              color:
                                feedbackText === "Very Difficult"
                                  ? "#ffffff"
                                  : feedbackText === "Difficult"
                                  ? "#ffffff"
                                  : feedbackText === "Moderate"
                                  ? "#78350f"
                                  : feedbackText === "Easy"
                                  ? "#064e3b"
                                  : feedbackText === "Very Easy"
                                  ? "#ffffff"
                                  : "#c2410c",
                              px: 1.2,
                              py: 0.5,
                              borderRadius: "8px",
                              display: "flex",
                              alignItems: "center",
                              fontWeight: 600,
                            }}
                          >
                            {feedbackText === "Very Difficult"
                              ? "😠 Very Difficult"
                              : feedbackText === "Difficult"
                              ? "😧 Difficult"
                              : feedbackText === "Moderate"
                              ? "😐 Moderate"
                              : feedbackText === "Easy"
                              ? "☺️ Easy"
                              : feedbackText === "Very Easy"
                              ? "😄 Very Easy"
                              : "⏩ Feedback Skipped"}
                          </Box>
                        </Box>
                        <Typography
                          variant="body2"
                          sx={{
                            color: "#4b5563",
                            fontSize: "14px",
                            lineHeight: 1.6,
                            mb: 2,
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            display: "-webkit-box",
                            WebkitLineClamp: 3,
                            WebkitBoxOrient: "vertical",
                          }}
                        >
                          {" "}
                          {history?.exam_description}
                        </Typography>
                        <Box sx={{ display: "flex", gap: 2 }}>
                          <Button
                            variant="contained"
                            sx={{
                              backgroundColor: "#0055ff",
                              textTransform: "none",
                              fontSize: "15px",
                              px: 2,
                              py: 1,
                              gap: "6px",
                              borderRadius: "8px",
                              color: "white",
                              flex: 1,
                              "&:hover": {
                                backgroundColor: "#0055ff",
                              },
                            }}
                            onClick={() => {
                              dispatch(clearListReExamID());
                              dispatch(clearlistStudentExam());
                              navigate("/instructionreExam", {
                                state: history?.id,
                              });
                            }}
                          >
                            <RefreshOutlinedIcon
                              sx={{
                                transform: "scaleX(-1)",
                                fontSize: "20px",
                              }}
                            />
                            Retake Test
                          </Button>

                          <Button
                            variant="outlined"
                            sx={{
                              textTransform: "none",
                              fontSize: "15px",
                              px: 2,
                              py: 1,
                              gap: "6px",
                              borderRadius: "8px",
                              flex: 1,
                              borderColor: "#cbd5e1",
                              color: "#020817",
                              "&:hover": {
                                color: "white",
                                backgroundColor: "#38C172",
                              },
                            }}
                            onClick={() =>
                              navigate("/examresult", {
                                state: {
                                  id: history?.id,
                                  showSubmitAlert: false, // or true if you want the alert
                                },
                              })
                            }
                          >
                            <SvgIcon
                              component={document_icon}
                              inheritViewBox
                              sx={{
                                fill: "none",
                                fontSize: "16px",
                              }}
                            />
                            View Report
                          </Button>
                        </Box>
                      </Paper>
                    </Grid>
                  );
                })
              ) : (
                <Grid item xs={12} sm={6} md={4} sx={{ marginBottom: "24px" }}>
                  <Paper
                    elevation={3}
                    sx={{
                      p: 2,
                      borderRadius: 2,
                      height: "100%",
                      display: "flex",
                      flexDirection: "column",
                      boxShadow: "none",
                    }}
                  >
                    {/* Card Header */}
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <Typography
                        component="h2"
                        sx={{
                          fontSize: "18px",
                          fontWeight: "medium",
                        }}
                      >
                        No Exam History Available
                      </Typography>
                    </Box>
                    <div
                      className="descritpionlist"
                      style={{
                        color: "#575757",
                        marginTop: "10px",
                        marginBottom: "10px",
                      }}
                    >
                      {" "}
                      You don't have any exam history at the moment. Please
                      attempt a exam to see your progress here.
                    </div>
                    <div>
                      <div
                        style={{
                          display: "flex",
                          gap: "10px",
                          width: "100%",
                          alignItems: "center",
                          justifyContent: "flex-end",
                        }}
                      >
                        <button
                          className="card-buttonexam"
                          onClick={() => {
                            navigate("/dashboard");
                          }}
                        >
                          <SvgIcon
                            component={Report}
                            inheritViewBox
                            sx={{ fill: "none" }}
                          />
                          <div style={{ fontSize: "14px" }}> Back to home</div>
                        </button>
                      </div>
                    </div>
                  </Paper>
                </Grid>
              )}
            </Grid>
          </Box>
        </Box>
      </div>
    </>
  );
};

export default ExamHistory;
